var n=function(n,o){n&&("focus"in n&&n.focus(o),"contentWindow"in n&&n.contentWindow&&n.contentWindow.focus())};export{n as focusOn};
//# sourceMappingURL=commands.js.map
